import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Reports: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Path
                d="M33.372 9.004H16.337a2.205 2.205 0 00-2.333 2.333v37.336a2.206 2.206 0 002.333 2.333h27.535a2.206 2.206 0 002.334-2.333V21.838L33.371 9.004zm0 0l6.417 6.417 6.416 6.417"
                fill="#fff"
            />
            <Path
                d="M33.372 9.004H16.337a2.205 2.205 0 00-2.333 2.333v37.336a2.206 2.206 0 002.333 2.333h27.535a2.206 2.206 0 002.334-2.333V21.838M33.371 9.004l6.417 6.417 6.416 6.417M33.373 9.004l12.834 12.834"
                stroke={props.color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                d="M20.631 43.262h18.79M20.631 37.736h18.79M20.631 32.21h18.79M20.631 26.684h18.79M20.631 21.158h8.842"
                stroke={props.color}
                strokeWidth={2}
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <Path
                d="M33.372 21.838h12.834l-6.417-6.417-6.417-6.417v12.834z"
                fill="#fff"
                stroke={props.color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Svg>
    );
};

export default React.memo(Reports);
